/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{createHtmlRenderState as t}from"../../html/utils/create-render-state.js";const r=()=>({...t(),attrs:{}});export{r as createSvgRenderState};
//# sourceMappingURL=create-render-state.js.map
